export default __webpack_public_path__ + "images/5042f83d93aff6aba2d2dea4de921360-language-icon--en.svg";